export default "__VITE_ASSET__WM5fVKBt__"